export default __webpack_public_path__ + "cb77baa6d25ee9317fc6394b526da4f5.jpg";